import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import PostLink from "../components/post-link";
// Components
import { Link } from "gatsby";
const _ = require("lodash");

const Tags = ({ pageContext, data, location: { pathname } }) => {
  console.log(data);
  const { tag } = pageContext;
  const { edges, pCount } = data.allMarkdownRemark || { edges: [], pCount: 0 };
  const { nEdges, nCount } = data.allJupyterNotebook || {
    nEdges: [],
    nCount: 0
  };
  const {
    tags: { group: tagList }
  } = data;
  const {
    notebookTags: { group: nTagList }
  } = data;
  const totalCount = pCount + nCount;
  const tagHeader = `${totalCount} post${
    totalCount + nCount === 1 ? "" : "s"
  } tagged with "${tag}"`;
  console.log(tagHeader);

  if (totalCount > 0) {
    const Posts = edges
      .concat(nEdges)
      .sort((a, b) => {
        const aDate =
          (a.node.frontmatter && a.node.frontmatter.date) ||
          a.node.json.metadata.frontmatter.date;
        const bDate =
          (b.node.frontmatter && b.node.frontmatter.date) ||
          b.node.json.metadata.frontmatter.date;
        return a > b ? 1 : -1;
      })
      // .filter(edge => !!edge.node.frontmatter.date)
      .map(edge => <PostLink key={edge.node.id} post={edge.node} />);
    // console.log(Posts);
    return (
      <Layout tags={_.uniq(tagList.concat(nTagList))} path={pathname}>
        <div>{Posts}</div>
      </Layout>
    );
  } else {
    return (
      <Layout tags={_.uniq(tagList.concat(nTagList))} path={pathname}>
        <div>No posts here.</div>
      </Layout>
    );
  }

  //   return (
  //     <Layout tags={tagList} path={pathname}>
  //       <div>
  //         <h1>{tagHeader}</h1>
  //         <ul>
  //           {edges.map(({ node }) => {
  //             const { path, title } = node.frontmatter;
  //             return (
  //               <li key={path}>
  //                 <Link to={path}>{title}</Link>
  //               </li>
  //             );
  //           })}
  //         </ul>
  //         {/*
  // 				This links to a page that does not yet exist.
  // 				We'll come back to it!
  // 				*/}
  //         <Link to="/tags">All tags</Link>
  //       </div>
  //     </Layout>
  //   );
};

Tags.propTypes = {
  pageContext: PropTypes.shape({
    tag: PropTypes.string.isRequired
  }),
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      pCount: PropTypes.number.isRequired,
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            frontmatter: PropTypes.shape({
              path: PropTypes.string.isRequired,
              title: PropTypes.string.isRequired
            })
          })
        }).isRequired
      )
    })
  })
};

export default Tags;

export const pageQuery = graphql`
  query TagPage($tag: String) {
    allMarkdownRemark(
      limit: 2000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      pCount: totalCount
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            title
            path
            author
            date
            tags
          }
        }
      }
    }

    allJupyterNotebook(
      sort: { order: DESC, fields: [metadata___frontmatter___date] }
      filter: { metadata: { frontmatter: { tags: { in: [$tag] } } } }
    ) {
      nCount: totalCount
      nEdges: edges {
        node {
          id
          json {
            metadata {
              frontmatter {
                path
                title
                tags
                author
                date(formatString: "MMMM DD, YYYY")
              }
            }
          }
        }
      }
    }

    notebookTags: allJupyterNotebook(limit: 2000) {
      group(field: metadata___frontmatter___tags) {
        fieldValue
      }
    }

    tags: allMarkdownRemark(
      limit: 2000
      filter: { frontmatter: { published: { ne: false } } }
    ) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`;
